<template>
  <div class="incomeWrap">
    <triggernav
      :triggerval="triggerval"
      :isblue="true"
      :titlevalue="titleValue"
    ></triggernav>

    <!-- 总收入 -->
    <div class="incomebox" v-show="triggerval.chooseIndex == 0">
      <div class="choosetime clearfix">
        <button class="inquirebtn defaultbtn fr">
          查询
        </button>
        <div class="fr">
          <span class="demonstration"> 起止时间：</span>
          <el-date-picker
            v-model="allChoooseTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="lineimgbox">
        <div id="myChart" :style="{ width: '920px', height: '300px' }"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" class="table-cell">
        <el-table-column
          prop="name"
          align="center"
          label="作品名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="allnum"
          align="center"
          label="总收入"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="type" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="hint" align="center" label="备注">
        </el-table-column>
      </el-table>
    </div>

    <!-- 本站收入 -->
    <div class="incomebox" v-show="triggerval.chooseIndex == 1">
      <div class="choosetime clearfix">
        <button class="inquirebtn defaultbtn fr">
          查询
        </button>
        <div class="fr">
          <el-select v-model="bookValue" filterable placeholder="请选择作品">
            <el-option
              v-for="item in bookoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" class="table-cell">
        <el-table-column
          prop="name"
          align="center"
          label="作品名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="allnum"
          align="center"
          label="总收入"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="type" align="center" label="类型">
        </el-table-column>
        <el-table-column prop="hint" align="center" label="备注">
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :total="500"
        :pager-count="pagecount"
        class="paginnation-book"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
/* // 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/line");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title"); */
export default {
  data() {
    return {
      triggerval: {
        chooseVal: ["总收入", "本站收入"],
        chooseIndex: 0 // 切换信息：基本 签约
      },
      orgOptions: {},
      titleValue: "合计收入：1234567元",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      allChoooseTime: "",
      tableData: [
        { name: "哈哈哈哈", allnum: 2222, type: "都市", hint: "完美" },
        { name: "哈哈哈哈", allnum: 2222, type: "都市", hint: "完美" },
        { name: "哈哈哈哈", allnum: 2222, type: "都市", hint: "完美" }
      ],
      /* 作品相关 */
      bookoptions: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      bookValue: "",
      pagecount: 5
    };
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        color: ["#84C9FC"],
        grid: {
          top: 30,
          left: 15,
          right: 40,
          bottom: 15,
          containLabel: true
        },
        title: {
          text: "收入趋势",
          subtext: "",
          textAlign: "left",
          padding: [
            15, // 上
            0, // 右
            5, // 下
            50 // 左
          ],
          textStyle: {
            //设置主标题风格
            Color: "#333333", //设置主标题字体颜色
            fontStyle: "", //主标题文字风格
            fontSize: 12,
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          data: ["最低"],
          right: "20px",
          padding: [5, 10],
          backgroundColor: "#E1F2FF"
        },
        dataRange: {
          backgroundColor: "#E1F2FF"
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          splitLine: {
            lineStyle: {
              color: "#E9E9E9",
              type: "dashed"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#E9E9E9",
              width: 1 //这里是为了突出显示加上的
            }
          },
          splitNumber: 20,
          axisLabel: {
            textStyle: {
              show: true,
              color: "#323232", //这里用参数代替了
              fontSize: 12
            }
          },
          data: [
            "2019-02-25",
            "2019-03-04",
            "2019-03-18",
            "2019-03-26",
            "2019-04-16",
            "2019-04-26",
            "2019-05-04"
          ]
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#E9E9E9",
              type: "dashed"
            }
          },
          splitNumber: 6,
          axisLine: {
            lineStyle: {
              color: "#E9E9E9",
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            textStyle: {
              show: true,
              color: "#323232", //这里用参数代替了
              fontSize: 12
            }
          },
          data: [0, 100, 200, 300, 400, 500, 600]
          /*  axisLabel: {
                                                                                                                                                                                                                                                                                                                                             formatter: "{value}"
                                                                                                                                                                                                                                                                                                                                           } */
        },
        series: [
          {
            name: "最低",
            type: "line",
            smooth: true,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#E1F2FF" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#E1F2FF" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            },
            data: [100, 50, 250, 400, 600, 500, 200],
            markPoint: {
              data: [{ name: "周最低", value: 2, xAxis: 1, yAxis: 1.5 }]
            },
            markLine: {
              data: [
                { type: "average", name: "平均值" },
                [
                  {
                    symbol: "none",
                    x: "90%",
                    yAxis: "max"
                  },
                  {
                    symbol: "circle",
                    label: {
                      normal: {
                        position: "start",
                        formatter: "最大值"
                      }
                    },
                    type: "max",
                    name: "最高点"
                  }
                ]
              ]
            }
          }
        ]
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.drawLine();
    });
  }
};
</script>
<style>
/* 分页 */
/* .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  min-width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(142, 142, 142, 1);
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #59b7f7;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #59b7f7;
  color: #fff;
} */
</style>
<style lang="stylus" scoped>
.incomeWrap
    min-height 656px
    padding-bottom 80px
    position relative
    .incomebox
        padding 20px 24px
        .lineimgbox
            background rgba(255, 255, 255, 1)
            border-radius 4px
            border 1px solid rgba(211, 211, 211, 1)
            margin-bottom 20px
        .choosetime
            height 54px
            background rgba(255, 255, 255, 1)
            border-radius 4px
            border 1px solid rgba(211, 211, 211, 1)
            line-height 54px
            margin-bottom 20px
            font-size 14px
            font-family PingFangSC-Regular
            font-weight 400
            color rgba(51, 51, 51, 1)
            .inquirebtn
                margin 13px 20px
        .paginnation-book
            position absolute
            bottom 30px
            right 24px
</style>
